module.exports = __webpack_public_path__ + "img/T919.2691c176.jpg";